/** Matches server enums (numeric JSON from SignalR). */

export enum BridgeActivityDirection {
  ZitadelToBus = 0,
  BusToZitadel = 1,
}

export enum BridgeActivityOutcome {
  Success = 0,
  Skipped = 1,
  Failed = 2,
}

export interface BridgeActivityEntry {
  id: string;
  timestampUtc: string;
  direction: BridgeActivityDirection;
  messageType: string;
  summary: string;
  outcome: BridgeActivityOutcome;
  correlationId?: string | null;
}

export interface BridgeActivityStatistics {
  total: number;
  zitadelToBus: number;
  busToZitadel: number;
  byMessageType: Record<string, number>;
}

export interface BridgeActivitySnapshot {
  statistics: BridgeActivityStatistics;
  recentEntries: BridgeActivityEntry[];
}
